import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

import { Store } from '@ngrx/store';
import * as LocaleActions from 'src/app/root-store/locale/locale.actions';
import * as ConfigActions from 'src/app/root-store/config/actions/config.actions';
import * as fromLocale from 'src/app/root-store/locale/locale.selectors';
import FuzzySet from 'fuzzyset';
@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private store: Store
  ) {
    super(router, keycloak);
  }

  labels = [];

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
      });
      return;
    }

    // Setting app localeId
    this.store.dispatch(LocaleActions.loadAppKeyValues({}));
    this.store.dispatch(LocaleActions.loadLocales());

    this.store.dispatch(ConfigActions.loadWFStatus());
    //  this.store.dispatch(userActions.loadUserProfile({userId:this.keycloak.getKeycloakInstance().subject}));

    return new Promise<boolean>((resolve, reject) => {
      const url = route['_routerState']['url'];
      this.store.select(fromLocale.getMenu).subscribe((data) => {
        if (!data) {
          return resolve(true);
        }
        const menus = JSON.parse(data);
        const menuMatched = this.findMenuMatch(menus, url);

        if (
          !(
            menuMatched &&
            menuMatched.menu.roles &&
            menuMatched.menu.roles instanceof Array &&
            menuMatched.menu.roles.length
          )
        ) {
          return resolve(true);
        }

        resolve(
          menuMatched.menu.roles.some((role) => this.roles.includes(role))
        );
      });
    });

    // // Get the roles required from the route.
    // const requiredRoles = route.data.roles;

    // // Allow the user to to proceed if no additional roles are required to access the route.
    // if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
    //   return true;
    // }

    // // Allow the user to proceed if all the required roles are present.
    // return requiredRoles.every((role) => this.roles.includes(role));
  }

  private findMenuMatch(menus: any[], url: string) {
    const fuzzySet = FuzzySet();
    fuzzySet.add(url);
    const urlMatchingGrams = [];
    for (const menu of menus) {
      if (menu.routerLink) {
        const weight = fuzzySet.get(menu.routerLink);
        if (weight) {
          urlMatchingGrams.push({ weight: weight[0][0], menu });
        }
      } else if (menu.items && menu.items.length) {
        urlMatchingGrams.push(this.findMenuMatch(menu.items, url));
      }
    }
    return urlMatchingGrams.reduce(
      (acc, item) => {
        return item.weight >= acc.weight ? item : acc;
      },
      { weight: 0 }
    );
  }
}
